export const mappedZoneToNameEvents = {
  EU: "Strefa UE",
  STD: "Standard",
  EXO: "Egzotyczna",
  BREXIT: "Strefa Wlk.Brytania i Gibraltar",
  HT: "Strefa Bezpieczny Roaming",
};
